import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import commonRootReducer from '../redux/commonRootReducer';
import myOpenRootReducer from '../redux/myOpenRootReducer';

const initialState = {
    activityTypes: [],
    authorizedApps: [],
    activeUser: null,
    habilitations: [],
    authenticatedUser: null,
    locationTitle: '',
    liquidBottle: null,
    activeDayImputations: [],
    current_day: null,
    dayValidationAuthorized: false,
    dayModificationAuthorized: false,
    workOrders: [],
};
const composeEnhancers =
    typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(thunk),
    // other store enhancers if any
);

const store = createStore(
    combineReducers({ ...commonRootReducer, ...myOpenRootReducer }),
    initialState,
    enhancer
);

export default store;
